/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupManagementModel } from '../../models/group-management-model';
import { GuidApiRespModel } from '../../models/guid-api-resp-model';

export interface ApiManagementGroupDeletePost$Params {
      body?: GroupManagementModel
}

export function apiManagementGroupDeletePost(http: HttpClient, rootUrl: string, params?: ApiManagementGroupDeletePost$Params, context?: HttpContext): Observable<StrictHttpResponse<GuidApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiManagementGroupDeletePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GuidApiRespModel>;
    })
  );
}

apiManagementGroupDeletePost.PATH = '/api/Management/Group/Delete';
